import { useUpdateVenue } from '@api';
import { useNotification } from '@common';
import { modals } from '@mantine/modals';
import { AxiosError } from 'axios';
import { useTranslation } from 'react-i18next';

const TRANS_KEY_MODAL = 'DELETE_VENUE_OPERATOR.CONFIRM_MODAL';
const TRANS_KEY_NOTIFICATION = 'NOTIFICATIONS.DELETE_VENUE_OPERATOR';

type UseDeleteVenueOperatorArgsType = {
  venueId: string;
};

type UseDeleteVenueOperatorReturnType = {
  handleDelete: () => void;
};

export const useDeleteVenueOperator = ({
  venueId,
}: UseDeleteVenueOperatorArgsType): UseDeleteVenueOperatorReturnType => {
  const { t } = useTranslation('venueDetailsGeneral');
  const { showError, showSuccess } = useNotification();
  const { mutate: mutateUpdate } = useUpdateVenue();

  const onSuccess = (): void => {
    showSuccess({
      title: `${TRANS_KEY_NOTIFICATION}.SUCCESS.TITLE`,
      message: `${TRANS_KEY_NOTIFICATION}.SUCCESS.MESSAGE`,
    });
  };

  const onError = (error: AxiosError): void => {
    showError({
      title: `${TRANS_KEY_NOTIFICATION}.ERROR.TITLE`,
      message: `${TRANS_KEY_NOTIFICATION}.ERROR.MESSAGE`,
      error: error,
    });
  };

  const onConfirm = (): void => {
    mutateUpdate(
      {
        id: venueId,
        data: { venueOperator: null },
      },
      {
        onSuccess,
        onError,
      }
    );
  };

  const handleDelete = (): void => {
    modals.openConfirmModal({
      title: t(`${TRANS_KEY_MODAL}.TITLE`),
      labels: {
        confirm: t(`${TRANS_KEY_MODAL}.CONFIRM_BUTTON`),
        cancel: t('CANCEL_BUTTON', { ns: 'common' }),
      },
      confirmProps: {
        color: 'red',
      },
      onConfirm,
    });
  };

  return { handleDelete };
};
